import { Component,OnInit, ViewChild, ElementRef } from '@angular/core';
import { ChartType, ChartOptions,ChartDataSets, RadialChartOptions } from 'chart.js';
import { SingleDataSet, Label, monkeyPatchChartJsLegend, monkeyPatchChartJsTooltip } from 'ng2-charts';
import {ReportserviceService}  from '../../reportservice.service';
import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { PatientDetailModel } from 'app/opdvisits/Models/patient_details.model';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { ExportService } from 'app/reports/services/export.service';
import { OperationData } from '../data';
import { AuthService } from 'app/auth/auth.service';


@Component({
  selector: 'app-operation-date-wise-report',
  templateUrl: './operation-date-wise-report.component.html',
  styleUrls: ['./operation-date-wise-report.component.scss']
})
export class OperationDateWiseReportComponent implements OnInit {


  public link: string = 'https://medium.com/@garfunkel61/angular-simplest-solution-for-social-sharing-feature-6f00d5d99c5e';  
  showspinner = false;
  patientcount;
  dataSource = new MatTableDataSource<PatientDetailModel>();
  startdate;
  enddate;
  pname = "";
  pageHeading:any;
  public toDaysDate:any;
  public operationArrayData:any =[];
  isShowDivIf = false;
  isGraph = false;
  ismonthly = false;
  isgrapandData = false;
  isdatewise = false;
  isnewcolor =false;
  public setcharttype;
  public senddataArray:any = [];
  public serchdata:any =[];
  public Labels =['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16',
  '17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','Total'];
  public TableLabels =['OP ','1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16',
  '17','18','19','20','21','22','23','24','25','26','27','28','29','30','31','Total'];
  
  public pieChartOptions: ChartOptions = {
    responsive: true,
  };
  public pieChartData: ChartDataSets[] = []
  public pieChartLabels: Label[] = this.Labels;
  public pieChartType: ChartType = 'pie';
  public pieChartLegend = true;
  public pieChartPlugins = [];
  
  
  
  constructor(public reportservice:ReportserviceService,public dbservice:DashboardService, 
    public opdvisitService: OpdVisitService, public authService :AuthService,
    private datePipe: DatePipe,private exportdata:ExportService) {
        monkeyPatchChartJsTooltip();
        monkeyPatchChartJsLegend();
        this.pageHeading = 'Operation Date Wise Reports'
        }
  
    ngOnInit(): void {
      this.operationArrayData =  OperationData;
      console.log( 'operationData',this.operationArrayData)
      this.toDaysDate = this.authService.getServerDate;
      this.toDaysDate = this.datePipe.transform(this.toDaysDate, "yyyy-MM-dd");
      console.log(this.toDaysDate);

      this.reportservice.get_opd_doctor_sdate_edate(this.toDaysDate,this.toDaysDate).
      subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
    this.dailygharps();
      }
  
  setgraptype(type){
   this.pieChartType =type;
  }
  
  toggleDisplayDivIf() {
    this.isShowDivIf = !this.isShowDivIf;
  }
  
  togglegraphIf() {
    this.isGraph = !this.isGraph;
  }
  
  togglegraphDataIf() {
    this.isgrapandData = !this.isgrapandData;
  }
  

  dailygharps(){
    //  console.log('daily');
     this.pieChartData = [
      { data: [18,10,18,17,19,16,15,18,19,21,29,22,20,29,32,72,22,52,30,20,21,24,25,26,27,27,30,50,20,30,35,780], label: 'OPD DateWise Analysis'},
      // { data: [8,10,8,7,9,6,5,8,9,11,9,8,3,5,78,67,34,44,55,5,6,7,8,3,45,6,6,6,54,4,33,456], label: 'Surgery DateWise Analysis', },
    
    ];
  
    }
  
    weeklygraphs(){
      // console.log('weekly');
      this.pieChartData = [
        { data: [28,20,28,27,39,26,35,28,39,31,29,22,20,29,32,72,42,52,40,30,31,44,45,26,37,47,50,70,30,40,55,1280], label: 'Surgery DateWise Analysis'},
        // { data: [18,20,28,27,29,26,25,38,29,21,29,28,23,25,58,67,34,44,55,15,16,17,18,13,45,26,36,16,54,24,33,856], label: 'Surgery DateWise Analysis', },
      
      ];
  
    }
  
    monthlygraphs(){
      // console.log('monthly');
      this.pieChartData = [
        { data: [128,120,128,227,139,126,135,218,139,131,229,122,220,129,132,172,142,152,140,130,131,144,145,126,137,147,150,170,130,140,155,11280], label: 'Surgery DateWise Analysis'},
        // { data: [118,120,128,120,129,126,125,138,129,121,129,128,123,125,158,167,134,144,155,115,116,117,118,113,145,126,136,116,154,124,133,1056], label: 'Surgery DateWise Analysis', },
      
      ];
  
    }
  
    quaterlygraphs(){
      // console.log('quaterly');
      this.pieChartData = [
        { data: [328,420,228,527,239,326,435,418,539,431,629,322,420,229,332,472,542,452,240,230,531,644,445,526,637,647,550,670,530,740,655,6456], label: 'Surgery DateWise Analysis'},
        // { data: [118,120,128,120,129,126,125,138,129,121,129,128,123,125,158,167,134,144,155,115,116,117,118,113,145,126,136,116,154,124,133,1056], label: 'Surgery DateWise Analysis', },
      
      ];
  
  
    }
  
  
  
  
  get_records_between_two_dates(){
   
    let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
    let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  
   this.reportservice.get_opd_doctor_sdate_edate(sdate,edate).
   subscribe(data => this.success_pat_sdate_edate(data), err => this.failed_pat_sdate_edate(err));
  }
  
  success_pat_sdate_edate(data){
    // this.operationArrayData =data;
    // console.log(data)

  }
  failed_pat_sdate_edate(err){
  this.showspinner = false;
  }
  
  

  exportexcel(): void 
    {
       let element = document.getElementById('content'); 
       this.exportdata.exportxcel(element);
     }
  
  
  public openPDF():void {
    let DATA = document.getElementById('content');
    this.exportdata.download(DATA);
        
  }
  
  printComponent(cmpName) {
    let printContents = document.getElementById(cmpName).innerHTML;
    this.exportdata.printData(printContents);
    
  }
  public printPDF(): void {
    this.exportdata.printpDFData(); 
}
 
  
  
  
  }